import { hash } from "@ember/helper";
import CloseDrawerButton from "./close-drawer-button";
import ClosePinsButton from "./close-pins-button";
import CloseThreadButton from "./close-thread-button";
import CloseThreadsButton from "./close-threads-button";
import Filter from "./filter";
import FullPageButton from "./full-page-button";
import NewChannelButton from "./new-channel-button";
import OpenDrawerButton from "./open-drawer-button";
import PinnedMessagesButton from "./pinned-messages-button";
import ThreadSettingsButton from "./thread-settings-button";
import ThreadTrackingDropdown from "./thread-tracking-dropdown";
import ThreadsListButton from "./threads-list-button";
import ToggleDrawerButton from "./toggle-drawer-button";

const ChatNavbarActions = <template>
  <nav class="c-navbar__actions">
    {{yield
      (hash
        OpenDrawerButton=OpenDrawerButton
        NewChannelButton=NewChannelButton
        ThreadTrackingDropdown=ThreadTrackingDropdown
        CloseThreadButton=CloseThreadButton
        CloseThreadsButton=CloseThreadsButton
        ClosePinsButton=ClosePinsButton
        ThreadSettingsButton=ThreadSettingsButton
        ThreadsListButton=ThreadsListButton
        PinnedMessagesButton=PinnedMessagesButton
        CloseDrawerButton=CloseDrawerButton
        ToggleDrawerButton=ToggleDrawerButton
        FullPageButton=FullPageButton
        Filter=Filter
      )
    }}
  </nav>
</template>;

export default ChatNavbarActions;
